import { Helmet } from 'react-helmet';
import { RestaurantSettlement } from 'src/components/RestaurantSettlement';

const RestaurantSettlementPage = () => (
  <>
    <Helmet>
      <title> Restaurant Transcations</title>
    </Helmet>

    <RestaurantSettlement />
  </>
);

export default RestaurantSettlementPage;
